/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Previous_ChargeInputs */

const en_previous_charge = /** @type {(inputs: Previous_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Charge`)
};

const es_previous_charge = /** @type {(inputs: Previous_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo anterior`)
};

/**
* | output |
* | --- |
* | "Previous Charge" |
*
* @param {Previous_ChargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const previous_charge = /** @type {((inputs?: Previous_ChargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previous_ChargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_previous_charge(inputs)
	return es_previous_charge(inputs)
});